<template>
  <b-modal
    id="matchingPMReadPopup"
    v-model="isShowModalMatchingRead"
    hide-footer
    hide-header
    no-close-on-backdrop
    size="xl"
  >
    <div
      v-if="itemSelected.requested && itemSelected.requester"
      class="bodyContents"
    >
      <header class="matchingPMReadPopupHeader">
        <h6 class="matchingPMReadPopupTitle">신청서 보기</h6>
        <button class="matchingPMReadPopupBtnClose" @click="handClose">
          <img
            :src="require('@/assets/svg/close.svg')"
            alt=""
            height="14px"
            width="14px"
          />
        </button>
      </header>
      <div class="bodyContent" id="matchingPMReadPopupText">
        <div
          class="matchingItemImages popupViewProfile"
          style="justify-content: start"
        >
          <CorpInfoCard
            v-if="
              itemSelected.requester &&
                itemSelected.requester.roleName == $role.CORP
            "
            :data="itemSelected.requester"
            hideHomepage
            hideBorder
          />
          <UserInfoCard
            v-else-if="
              itemSelected.requester &&
                itemSelected.requester.roleName == $role.USER
            "
            :data="itemSelected.requester"
            hideBorder
          />

          <div class="matchingBtnInside">
            <img
              :src="require('@/assets/svg/next.svg')"
              alt=""
              height="18px"
              width="18px"
            />
          </div>

          <CorpInfoCard
            v-if="
              itemSelected.requested &&
                itemSelected.requested.roleName == $role.CORP
            "
            :data="itemSelected.requested"
            nameColor="#502423"
            hideHomepage
            hideBorder
          />
          <UserInfoCard
            v-else-if="
              itemSelected.requested &&
                itemSelected.requested.roleName == $role.USER
            "
            :data="itemSelected.requested"
            nameColor="#502423"
            hideBorder
          />
        </div>

        <MainButton
          :btnText="getBtnLabel(itemSelected.status)"
          size="small"
          :color="getBtnLightColor(itemSelected.status)"
        />

        <h3 class="matchingHeadLine">신청서</h3>

        <LabelInput
          label="신청 대상 회원"
          :value="itemSelected.requested.name"
        />
        <LabelInput
          label="매칭신청 사유"
          type="textarea"
          :value="itemSelected.requestReason"
        />

        <div class="line"></div>
        <h3 class="matchingHeadLine">연락처 정보</h3>

        <LabelInput label="신청자 이름" :value="itemSelected.requester.name" />

        <LabelInput label="이메일 주소" :value="itemSelected.requester.email" />

        <LabelInput
          label="전화번호"
          :value="itemSelected.requester.phoneNumber"
        />

        <div class="btnSubmit">
          <MainButton
            type="submit"
            btnText="닫기"
            width="191px"
            color="gray"
            @click="onClickSignin"
          />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import matchingColorMixins from "@/mixins/matching-color-mixins";
import LabelInput from "@/components/formControl/LabelInput.vue";
import CorpInfoCard from "@/components/items/CorpInfoCard.vue";
import UserInfoCard from "@/components/items/UserInfoCard.vue";

export default {
  name: "MatchingPMReadPopup",
  mixins: [matchingColorMixins],
  props: {
    isShowModalMatchingRead: Boolean,
    itemSelected: Object,
  },
  data() {
    return {
      signinInfo: {
        test: "이승철",
        email: "asdfasdfasdf@gmail.com",
        phone: "000-1111-1111",
      },
    };
  },
  watch: {
    itemSelected(newVal) {
      console.log("ItemSelected:", newVal);
    },
  },
  methods: {
    handClose() {
      this.$emit("close-modal");
    },

    onClickSignin() {
      this.$emit("close-modal");
    },
  },
  components: {
    MainButton,
    LabelInput,
    CorpInfoCard,
    UserInfoCard,
  },
};
</script>

<style scoped lang="scss">
.line {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
  border-bottom: 1px solid #d6d6d6 !important;
}

.bodyContents {
  .matchingPMReadPopupHeader {
    background-color: #26336a;
    display: flex;
    justify-content: space-between;
    height: 48px;
    align-items: center;
    padding-left: 24px;
    padding-right: 10px;
    margin: -1rem;

    .matchingPMReadPopupTitle {
      color: #fff;
    }

    .matchingPMReadPopupBtnClose {
      height: 32px;
      width: 32px;
      padding: 0px;
      cursor: pointer;
      border-radius: 50%;
      border: 0px;
      background-color: transparent;
    }
  }

  .bodyContent {
    margin: 16px;
    border-top: 1px solid #d6d6d6;
    margin-top: 24px;
    max-height: calc(100vh - 120px);
    overflow: auto;
  }

  .bodyContent::-webkit-scrollbar {
    display: none;
  }
}

.matchingHeadLine {
  border-bottom: 1px solid #d6d6d6;
  padding-top: 40px;
  padding-bottom: 24px;
  margin-bottom: 16px;
  color: #26336a;
}
.inputBoxMatching {
  display: flex;
  flex-direction: column;

  label {
    font-size: 16px;
    color: #000000;
    padding-bottom: 24px;
    padding-top: 24px;
  }

  input {
    border: 0px !important;
    background-color: #f4f4f4;
    height: 45px !important;
    padding-left: 10px !important;

    &:focus {
      // outline-color: #954A48;
      outline: none;
    }
  }

  textarea {
    padding-top: 12px !important;
    padding-left: 10px !important;
    border: 0px !important;
    background-color: #f4f4f4;
    resize: none;

    &:focus {
      outline: none;
    }
  }
}

.btnSubmit {
  border-top: 1px solid #d6d6d6;
  padding-top: 24px;
  margin-top: 24px;
  display: flex;
  justify-content: center;
}

.matchingImage {
  img {
    height: auto;
    width: auto;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }

  figure {
    display: flex;
    height: 160px;
    width: 160px;
  }
}
</style>
